import { render, staticRenderFns } from "./sdproduct2.vue?vue&type=template&id=598ea029&scoped=true"
import script from "./sdproduct2.vue?vue&type=script&lang=js"
export * from "./sdproduct2.vue?vue&type=script&lang=js"
import style0 from "./sdproduct2.vue?vue&type=style&index=0&id=598ea029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ea029",
  null
  
)

export default component.exports